import safeLocalStorage from 'client/lib/safeLocalStorage';

export default function setTourGuideReportValues({ state }, {
  tourGuideReportsByTourId,
}) {
  state.set(['agent', 'tourGuideReportsByTourId'], tourGuideReportsByTourId);
  safeLocalStorage.setItem('tourGuideReportsByTourId', JSON.stringify(tourGuideReportsByTourId));
}
